"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WeChatIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** WeChatIcon */
var WeChatIcon = function WeChatIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "WeChat" : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({
    viewBox: "0 0 18 18"
  }, rest), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M14.543 13.223c.889-.645 1.457-1.597 1.457-2.657 0-1.94-1.888-3.513-4.217-3.513-2.329 0-4.217 1.573-4.217 3.513 0 1.941 1.888 3.514 4.217 3.514.481 0 .946-.068 1.377-.192l.123-.019c.082 0 .155.025.224.065l.924.533.08.026a.14.14 0 0 0 .142-.14l-.023-.103-.19-.709-.015-.09a.28.28 0 0 1 .118-.228zM7.06 3.173C4.266 3.173 2 5.061 2 7.39c0 1.27.681 2.415 1.748 3.188.086.06.142.16.142.274l-.018.108-.228.85-.027.123c0 .094.076.17.169.17l.098-.032 1.107-.64a.53.53 0 0 1 .269-.078l.148.023a5.984 5.984 0 0 0 1.652.231l.278-.007a3.259 3.259 0 0 1-.17-1.033c0-2.124 2.066-3.846 4.615-3.846l.275.007c-.381-2.014-2.473-3.555-4.998-3.555zm3.317 6.832a.562.562 0 1 1 .001-1.125.562.562 0 0 1 0 1.125zm2.812 0a.562.562 0 1 1 0-1.125.562.562 0 0 1 0 1.125zm-7.816-3.29a.674.674 0 1 1 0-1.348.674.674 0 0 1 0 1.348zm3.374 0a.674.674 0 1 1 0-1.348.674.674 0 0 1 0 1.348z",
    fill: (0, _helpers.color)(rest.fill),
    fillRule: "evenodd"
  }));
};

exports.WeChatIcon = WeChatIcon;
WeChatIcon.displayName = "WeChatIcon";
//# sourceMappingURL=WeChatIcon.js.map